import client from "./client";

function toNullIfBlank(value) {
  if (value === undefined || value === null) return null;
  const text = String(value).trim();
  return text === "" ? null : text;
}

function normalizeBoolean(value, fallback = true) {
  if (value === undefined || value === null || value === "") return fallback;
  if (value === true || value === 1 || value === "1") return true;
  if (value === false || value === 0 || value === "0") return false;
  return Boolean(value);
}

function normalizeInstitution(row = {}) {
  return {
    uuid: row.uuid ?? row.id ?? null,
    id: row.id ?? row.uuid ?? null,
    name: row.name ?? "",
    institution_type: row.institution_type ?? row.institutionType ?? "",
    institutionType: row.institutionType ?? row.institution_type ?? "",
    state: row.state ?? null,
    is_active: normalizeBoolean(row.is_active ?? row.isActive, true),
    isActive: normalizeBoolean(row.isActive ?? row.is_active, true),
    created_at: row.created_at ?? row.createdAt ?? null,
    createdAt: row.createdAt ?? row.created_at ?? null,
    updated_at: row.updated_at ?? row.updatedAt ?? null,
    updatedAt: row.updatedAt ?? row.updated_at ?? null,
  };
}

function buildInstitutionPayload(payload = {}) {
  return {
    name: toNullIfBlank(payload.name),
    institution_type: toNullIfBlank(payload.institution_type ?? payload.institutionType),
    state: toNullIfBlank(payload.state),
    is_active: normalizeBoolean(payload.is_active ?? payload.isActive, true),
  };
}

function unwrapPayload(responseData) {
  const envelope = responseData ?? {};
  return envelope.data ?? envelope;
}

function extractInstitutionList(responseData) {
  const payload = unwrapPayload(responseData);
  const items =
    Array.isArray(payload) ? payload :
    Array.isArray(payload.items) ? payload.items :
    Array.isArray(payload.results) ? payload.results :
    [];

  return items.map(normalizeInstitution);
}

function extractInstitutionRecord(responseData) {
  const payload = unwrapPayload(responseData);
  if (Array.isArray(payload)) return normalizeInstitution(payload[0] ?? {});
  if (payload?.item) return normalizeInstitution(payload.item);
  if (payload?.items && Array.isArray(payload.items)) {
    return normalizeInstitution(payload.items[0] ?? {});
  }
  return normalizeInstitution(payload);
}

export const institutionApi = {
  async list(params = {}) {
    const { data } = await client.get("/v1/institutions", { params });
    return extractInstitutionList(data);
  },

  async get(uuid) {
    const { data } = await client.get(`/v1/institutions/${uuid}`);
    return extractInstitutionRecord(data);
  },

  async create(payload) {
    const { data } = await client.post("/v1/institutions", buildInstitutionPayload(payload));
    return extractInstitutionRecord(data);
  },

  async update(uuid, payload) {
    const { data } = await client.put(`/v1/institutions/${uuid}`, buildInstitutionPayload(payload));
    return extractInstitutionRecord(data);
  },

  async remove(uuid) {
    const { data } = await client.delete(`/v1/institutions/${uuid}`);
    return unwrapPayload(data);
  },
};

export { normalizeInstitution };
